import React from 'react'
import { StyledSrOnly } from './screen-reader-only.style'

export enum ScreenReaderOnlyAs {
    LEGEND = 'legend',
    SPAN = 'span',
}

type ScreenReaderOnlyProp = {
    description: string
    id: string
    typeAs?: ScreenReaderOnlyAs
}

export const ScreenReaderOnly = ({ id, description, typeAs = ScreenReaderOnlyAs.LEGEND }: ScreenReaderOnlyProp) => {
    return (
        <StyledSrOnly {...{ as: typeAs }} id={id}>
            {description}
        </StyledSrOnly>
    )
}
